// extracted by mini-css-extract-plugin
export var deleteIcon = "_p2-5";
export var deleteOption = "_p2-3";
export var divider = "_p2-2";
export var downloadIcon = "_p2-4";
export var drawer = "_p2-0";
export var drawerFooter = "_p2-6";
export var drawerOpen = "_p2-1";
export var highlighted = "_p2-7";
export var lighterHighlight = "_p2-8";